$(document).ready(function() {
    // Hljs
    document.querySelectorAll('pre code').forEach(codeElement => {
        hljs.highlightBlock(codeElement);
    });

    // Hljs line number
    document.querySelectorAll('code.hljs.linenumber').forEach(codeElement => {
        hljs.lineNumbersBlock(codeElement);
    });

    // Activate link
    document.querySelectorAll('.sidebar ul li > ul li > a').forEach(aHref => {
        if (aHref.getAttribute("href") === window.location.pathname) {
            aHref.classList.add('active');
        }
    });

    document.querySelectorAll('#myTabContentAnswers a').forEach(aHref => {
        aHref.setAttribute("target", "_blank");
        aHref.setAttribute("rel", "noopener noreferrer nofollow");
    });

    document.querySelectorAll('#myTabContentAnswers pre').forEach(pre => {
        pre.classList.add('black');
    });

    // Enable popovers
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover-info"]');
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl, {
        container: 'body',
        trigger: 'hover',
        offset: [0,8]
    }));

    // Add clipboard functionality
    function addClipboardJS() {
        var clipboard = new ClipboardJS(".btn-clipboard", {
            target: function(clipboard) {
                if($(clipboard.nextElementSibling).find('.clipboard-this')[0] !== undefined) {
                    return $(clipboard.nextElementSibling).find('.clipboard-this')[0];
                }
                return clipboard.nextElementSibling;
            }
        });
        clipboard.on("success", function(clipboard) {
            $(clipboard.trigger).text('Copied!');
            setTimeout(function () {
                $(clipboard.trigger).text('Copy');
            }, 1000);
            clipboard.clearSelection();
        });
        clipboard.on("error", function(clipboard) {
            var label = /Mac/i.test(navigator.userAgent) ? "⌘" : "Ctrl-";
            var text = "Press " + label + "C to copy";
            $(clipboard.trigger).text(text);
        });
    }

    function wrapperHighlight() {
        $('.docs-exception pre.copy').wrap('<div class="pre-wrapper"></div>');
        $('.pre-wrapper').prepend('<button class="btn-clipboard" title="Copy to clipboard">Copy</button>');
        addClipboardJS();
    }

    wrapperHighlight();
});